import { useCallback, useRef, useState } from "react";
import { cn } from "@/lib/utils";

export default function ScrollContainer({
    children,
    className,
    ref,
    onScrollFromTop,
    ...rest
}: {
    children: React.ReactNode;
    className?: string;
    ref?: React.RefObject<HTMLDivElement | null>;
    onScrollFromTop?: (scrollTop: number) => void;
} & React.HTMLAttributes<HTMLDivElement>) {
    const scrollTimer = useRef<NodeJS.Timeout | null>(null);
    const [isScrolling, setIsScrolling] = useState(false);

    const handleScroll = useCallback(
        (e: React.UIEvent<HTMLDivElement>) => {
            setIsScrolling(true);
            if (scrollTimer.current) {
                clearTimeout(scrollTimer.current);
            }
            scrollTimer.current = setTimeout(() => {
                setIsScrolling(false);
            }, 2400);
            onScrollFromTop?.(e.currentTarget.scrollTop);
        },
        [onScrollFromTop]
    );

    return (
        <div onScroll={handleScroll} className={cn("custom-scrollbar", className, isScrolling && "scrolling")} {...rest} ref={ref}>
            {children}
        </div>
    );
}
